// extracted by mini-css-extract-plugin
export var filter = "graphql-results-table-module--filter--3TgYh";
export var filtersBar = "graphql-results-table-module--filters-bar--3WuPh";
export var select = "graphql-results-table-module--select--1gXXy";
export var tableContainer = "graphql-results-table-module--table-container--Bmmft";
export var tableNoResults = "graphql-results-table-module--table-no-results--1Xy9B";